import React from 'react';
import { Typography } from 'antd';
import styles from './index.module.scss';
import HomeMeetingEmpty from 'asset/image/home_metting_empty_img@2x.png';
import cooperationSDK from 'lib/cooperationSdk';
import useConstant from 'use-constant';
import WithPrivateCheck from 'component/WithPrivateCheck';

const { Link } = Typography;

const jump = (url: string) => {
  // 协同平台跳转
  cooperationSDK.openExternal(url);
};

// 容器组件
const None: React.FC = () => {
  const href = useConstant(() => 'http://www.maxhub.com/login/');
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.title}>MAXHUB 会议预约系统</div>
        <div className={styles.content}>
          <img src={HomeMeetingEmpty} className={styles.banner} />
          <div className={styles.topContent}>
            <div className={styles.tipsTitle}>当前还没加入任何企业</div>
            <div className={styles.tips}>创建企业请联系IT管理员进行操作</div>
          </div>
          <div className={styles.tips}>或通过会议管理后台创建企业</div>
          <WithPrivateCheck hide>
            <div className={styles.tips}>
              后台地址：
              <Link href={href} target="_blank" onClick={() => jump(href)}>
                {href}
              </Link>
            </div>
          </WithPrivateCheck>
        </div>
      </div>
    </div>
  );
};

export default None;
